import { Injectable } from "@angular/core";
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // إضافة الهيدر المطلوب
        const modifiedReq = req.clone({
            setHeaders: {
                "Abp.TenantId": abp.multiTenancy.getTenantIdCookie().toString(),
            },
        });

        return next.handle(modifiedReq);
    }
}



// WEBPACK FOOTER //
// ./src/auth-header.interceptor.ts